// External libraries
import React from 'react';
import { LoadingElement } from '@/components/Common';

// Internal modules
// @ts-expect-error untyped-import
import { lazyLoader } from '@/lib';
import { KYCFields } from './KYCFields';
import { KanaAndKanjiNames } from './KanaAndKanjiNames';

const LazyKYCFields = lazyLoader({
  loader: () => import('./KYCFields'),
  loading: () => <LoadingElement />,
  name: 'kyc_inputs',
  // @ts-expect-error instead of using any to define props
  render(loaded, props) {
    // @ts-expect-error This worked pre typescript
    // KYCFields returns an array
    return <KYCFields {...props} />;
  },
});

const LazyKanaAndKanjiNames = lazyLoader({
  loader: () => import('./KanaAndKanjiNames'),
  loading: () => <LoadingElement />,
  name: 'kana_and_kanji_names_input',
  render() {
    return <KanaAndKanjiNames />;
  },
});

export { LazyKanaAndKanjiNames, LazyKYCFields };
